import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";
import { Room } from "livekit-client";

export enum LiveKitActionMessageType {
  RequestAssessmentTime = "request_assessment_time",
  TerminateAssessment = "terminate_assessment",
  RequestAssessmentQuestionIndex = "request_assessment_question_index",
}

export const sendLiveKitMessage = async (action: LiveKitActionMessageType, room: Room, assessmentId: string) => {
  if (!room) {
    return;
  }

  const message = {
    action,
    assessmentId,
  };

  room.localParticipant.publishData(new TextEncoder().encode(JSON.stringify(message)), { reliable: true });
};

export const fetchLiveKitToken = async (
  assessmentId: string,
  onTokenFetched: (token: string) => void,
  onError: () => void
) => {
  const storageToken = await AsyncStorage.getItem("token");
  try {
    const data = await axios.post(
      "/api/livekit/token",
      {
        assessmentId,
      },
      {
        headers: {
          Authorization: `Bearer ${storageToken}`,
        },
      }
    );
    onTokenFetched(data.data.token);
  } catch (error) {
    console.error("Error fetching LiveKit token:", error);
    onError();
  }
};
